import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Spinner,
  Select,
  Icon,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCircle, FaFileExport, FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../atoms/componentState";
import Pagination from "../../../defaultComponents/pagination";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import SalesListAPI from "../../../services/SalesListApi";
import {
  basicInfo,
  ClientInterface,
  statusInfo,
} from "../../../interfaces/defaultInterfaces";
import SystemApi from "../../../services/systemApi";
import ValueDropdown from "./defaultComponent/valueDropdown";
import { LoggedUser } from "../../../atoms/userLogged";
import jwt_decode from "jwt-decode";
import ModalSalesListDetail from "./components/modalSaleListDetail";
import ExtratoApi from "../../../services/ExtratoAPI";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import { customColors } from "../../../atoms/customColors";
import { dateForListWithHours } from "../../../constants/dataFormat";

// interface objetoSalesList {
//   bandeira: {
//     bandeira: string;
//     id: number;
//   };
//   bandeiraCartao: string;
//   cartaoFim: string;
//   cartaoInicio: string;
//   clienteNome: string;
//   descricaoEC: string;
//   id: number;
//   cliente: ClientInterface;
//   idBandeira: string;
//   idCustomer: string;
//   idPos: string;
//   idPagamento: string;
//   idProvider: number;
//   idSeller: string;
//   idTransacao: string;
//   modoPagamento: string;
//   moeda: string;
//   numeroTransacao: string;
//   parcelas: number;
//   status: string;
//   taxaCliente: number;
//   taxaPlano: number;
//   taxaZoop: number;
//   taxas: number;
//   urlBoleto: string;
//   urlPIX: string;
//   valor: number;
//   valorLiquido: number;
//   valorOriginal: number;
//   dataCriacao: any;
//   dataExpiracao: string;
//   dataPagamento: any;
//   nomePagador: string;
//   estabelecimento: string;
// }

interface objetoSalesList {
  bandeira: string;
  bandeiraCartao: string;
  cartaoFim: string;
  cartaoInicio: string;
  clienteNome: string;
  cnpj: string;
  codigoAutorizacao: string;
  codigoAutorizacaoId: string;
  codigoNsu: string;
  dataAtualizacao: string;
  dataCriacao: string;
  dataEstorno: string;
  dataExpiracao: string;
  dataPagamento: string;
  dataReversao: string;
  nulldescricaoEC: string;
  id: number;
  idBandeira: number;
  idCliente: number;
  idCustomer: string;
  idModoPagto: number;
  idPOS: string;
  idPagamento: string;
  idProduto: number;
  idProjeto: number;
  idProvider: number;
  idSeller: string;
  idStatus: number;
  idTransacao: string;
  isCnpj: boolean;
  isCreditCard: boolean;
  modoPagamento: string;
  moeda: string;
  nome: string;
  nomeFantasia: string;
  nomeModoPgto: string;
  nomeProduto: string;
  nomeProjeto: string;
  numeroTransacao: string;
  parcelas: number;
  qrCodePIX: string;
  razaoSocial: string;
  reference_id: number;
  serialPOS: string;
  sobrenome: string;
  status: string;
  statusTransacao: string;
  taxaCliente: number;
  taxaPlano: number;
  urlBoleto: string;
  urlPIX: string;
  valor: number;
  valorLiquido: number;
  valorOriginal: number;
}

export interface JWTToken {
  primarysid: string;
  idTipoUsuario: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
  loginPermissoes?: string;
}

export default function SalesListDashboard() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<objetoSalesList>);
  const [itemDetails, setItemDetails] = useState<objetoSalesList>();
  const [isOpen, setIsOpen] = useState(false);

  const colors = useRecoilState(customColors)[0];

  const user = useRecoilState(LoggedUser)[0];
  const idUser = user.id;
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
  let dias = moment(dataFim).diff(dataInicio, "days") >= 32;
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  async function getSalesList() {
    try {
      setLoading(true);
      if (!search) {
        const response = await SalesListAPI.getSalesList(
          currentPage,
          pageSize,
          filtros.initialDateFilter,
          filtros.finalDateFilter,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter
        );
        setSalesList(response.data);
        setPages(
          Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
        );
      } else {
        const response = await SalesListAPI.getSalesList(
          currentPage,
          pageSize,
          filtros.initialDateFilter,
          filtros.finalDateFilter,
          search,
          Number(jwtToken.idCliente),
          filtros.minValueFilter,
          filtros.maxValueFilter,
          filtros.statusFilter,
          filtros.saleTypeFilter
        );
        setSalesList(response.data);
        const lenght = response.data.length;
        setPages(Math.ceil(lenght / pageSize));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getSalesList();
    }
  }, [pages]);
  useEffect(() => {
    getSalesList();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
  }, []);
  const [clientList, setClientList] = useState(Array<ClientInterface>);
  const [statusList, setStatusList] = useState(Array<statusInfo>);
  const [modoPgtoList, setmodoPgtoList] = useState(Array<basicInfo>);

  async function Export() {
    try {
      setLoading(true);
      const response = await ExtratoApi.exportFile(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        "",
        filtros.saleTypeFilter,
        filtros.statusFilter
      );
      fileDownload(response, "relatorio.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getModoPgtoList() {
    try {
      const response = await SystemApi.getTransacoesModoPagamento();
      setmodoPgtoList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    // getClientList();
    getStatusList();
    getModoPgtoList();
  }, []);
  const clientOptions =
    clientList &&
    clientList.map((client) => {
      return {
        key: client.id,
        value: client.id,
        text:
          client?.isCnpj === true
            ? client?.razaoSocial
            : `${client.nome} ${client.sobrenome}`,
      };
    });
  const statusOptions =
    statusList &&
    statusList.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });
  const modoPgtoOptions =
    modoPgtoList &&
    modoPgtoList.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.nome,
      };
    });

  function onChangeClientFilter(e: any) {
    setFiltros({ ...filtros, clientFilter: Number(e.target.value) });
  }
  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }
  function onChangeModoPgtoFilter(e: any) {
    setFiltros({ ...filtros, saleTypeFilter: Number(e.target.value) });
  }

  console.log("filtros", filtros);

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Lista de Vendas
          </Text>
        </Flex>
        {/* <Flex px={8} py={3} my={4} alignItems="center">
          <Flex
            mr={4}
            border={`2px solid ${BLUEMONEDDBUTTONS}`}
            borderRadius={"6px"}
          >
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              Recebidos
            </Text>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              R$ 0,00
            </Text>
          </Flex>
          <Flex border={`2px solid ${BLUEMONEDDBUTTONS}`} borderRadius={"6px"}>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              A Receber
            </Text>
            <Text mx={4} my={1} fontWeight={"bold"} color={BLUEMONEDDBUTTONS}>
              R$ 0,00
            </Text>
          </Flex>
        </Flex>
        <Flex
          maxW={"53%"}
          px={8}
          py={3}
          my={4}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaPlus} />
            GERAR NOVO BOLETO
          </Button>
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaSearch} />
            CONSULTAR
          </Button>
          <Button
            bg={"none"}
            color={BLUEMONEDDBUTTONS}
            isDisabled={true}
            onClick={() => {
              // goToDashboard(navigate);
            }}
          >
            <Icon mr={2} as={FaFileExport} />
            Exportar Boleto
          </Button>
        </Flex>*/}
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        px={10}
        flexDirection={"column"}
      >
        <Text mb={1} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex
          width={"100%"}
          height={"100%"}
          justifyContent="space-evenly"
          mt={4}
          flexDirection={"column"}
        >
          <Flex py={3} w={"100%"} justifyContent="space-between">
            <Select
              placeholder="Filtrar por Status"
              maxW={"18%"}
              fontSize={"1.8vh"}
              value={filtros.statusFilter}
              onChange={onChangeStatusFilter}
            >
              {statusOptions.map((item) => {
                return (
                  <option value={item.value} key={item.key}>
                    {item.text}
                  </option>
                );
              })}
            </Select>
            <Select
              placeholder="Filtrar por Tipo de Venda"
              maxW={"18%"}
              fontSize={"1.8vh"}
              value={filtros.saleTypeFilter}
              onChange={onChangeModoPgtoFilter}
            >
              {modoPgtoOptions.map((item) => {
                return (
                  <option value={item.value} key={item.key}>
                    {item.text}
                  </option>
                );
              })}
            </Select>
            <DateDropdownDeafult filtros={filtros} setFiltros={setFiltros} />
            <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
            <Button
              bg={"none"}
              color={colors.BLUEMONEDDBUTTONS}
              isDisabled={loading || dias}
              onClick={() => {
                Export();
              }}
              mx="10px"
              isLoading={loading}
              textTransform={"uppercase"}
              leftIcon={<FaFileExport />}
            >
              {/* <Icon mr={2} as={FaFileExport} /> */}
              <Text fontSize={"0.8rem"}>Exporte o seu relatório</Text>
            </Button>
            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              fontSize={"1.8vh"}
              onClick={() => {
                setFiltros(initialValues);
              }}
            >
              Limpar Filtros
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Box width={"100%"} height={"85%"} mt={"0.1%"} mx="auto" py={3} px={10}>
        {loading ? (
          <Flex
            w={"100%"}
            // h={"66vh"}
            alignItems={"center"}
            justifyContent={"center"}
            px={4}
            flexDirection="column"
          >
            <Spinner size={"lg"} color={colors.VARIANT} />
          </Flex>
        ) : (
          <TableContainer borderRadius="8px">
            <Table variant="striped" size="sm" overflowY="scroll">
              <Thead h="50px" position="sticky" top="0">
                <Tr>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    EC
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Status
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Pagador
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Vencimento
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data de Pagamento
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor Total
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    %Taxa
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor Tarifa
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor Liquido
                  </Th>
                  {/* <Th bgColor={VARIANT} color={WHITE}>
                                    Estabelecimento
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    ID de transação
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    Tipo de Venda
                                </Th>
                                <Th bgColor={VARIANT} color={WHITE}>
                                    Valor
                                </Th> */}
                  {/* <Th bgColor={VARIANT} color={WHITE}>
                                    Ações
                                </Th> */}
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        cursor="pointer"
                        onClick={() => {
                          setIsOpen(true);
                          setItemDetails(item);
                        }}
                      >
                        <Th>
                          {moment(item.dataCriacao).format(
                            dateForListWithHours
                          )}
                        </Th>
                        <Th>
                          {item.isCnpj === true
                            ? item.razaoSocial
                            : `${item.razaoSocial} ${item.nomeFantasia}`}
                        </Th>
                        <Th>
                          <Flex flexDirection={"row"}>
                            {(item.status === "succeeded" && (
                              <>
                                <Icon mr={2} as={FaCircle} color={"green"} />{" "}
                                Sucesso
                              </>
                            )) ||
                              (item.status === "pending" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"yellow"} />{" "}
                                  Pendente
                                </>
                              )) ||
                              (item.status === "failed" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"orange"} />{" "}
                                  Falhou
                                </>
                              )) ||
                              (item.status === "new" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"gray"} />{" "}
                                  Nova
                                </>
                              )) ||
                              (item.status === "charged_back" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"black"} />{" "}
                                  ChargeBack{" "}
                                </>
                              )) ||
                              (item.status === "canceled" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"red"} />{" "}
                                  Cancelado{" "}
                                </>
                              )) ||
                              (item.status === "reversed" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"purple"} />{" "}
                                  Revertido{" "}
                                </>
                              )) ||
                              (item.status === "dispute" && (
                                <>
                                  <Icon mr={2} as={FaCircle} color={"pink"} />{" "}
                                  Em Disputa{" "}
                                </>
                              ))}
                          </Flex>
                        </Th>
                        <Th>{item.clienteNome}</Th>
                        <Th>
                          {item.dataExpiracao
                            ? moment(item.dataExpiracao).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "- -"}
                        </Th>
                        <Th>
                          {item.dataPagamento
                            ? moment(item.dataPagamento).format("DD/MM/YYYY")
                            : "- -"}
                        </Th>
                        <Th>
                          {item.valor
                            ? item.valor.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "R$ 0,00"}
                        </Th>
                        <Th>
                          {item.taxaPlano ? `${item.taxaPlano} %` : "0 %"}
                        </Th>
                        <Th>
                          {item.taxaCliente
                            ? item.taxaCliente.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "R$ 0,00"}
                        </Th>
                        <Th>
                          {item.valorLiquido
                            ? item.valorLiquido.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : item.valorLiquido}
                        </Th>
                        {/* <Th>{item.clienteNome}</Th>
                                            <Th>{item.idTransacao}</Th>
                                            <Th w={"fit-content"}>
                                                <CardImageList key={index} text={item.bandeiraCartao}>
                                                    {item.bandeiraCartao}
                                                </CardImageList>
                                            </Th>
                                            <Th>{item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</Th> */}
                        {/* <Th>
                                                <Flex
                                                    w={"100%"}
                                                    cursor="pointer"
                                                    onClick={() => {
                                                        setIsOpen(true);
                                                        
                                                    }}
                                                >
                                                    <Icon mr={2} as={FaEye} /> <Text>Detalhes</Text>
                                                </Flex>
                                            </Th> */}
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
        )}
        <ModalSalesListDetail
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          item={itemDetails}
        />
        <Flex width={"100%"} justifyContent="center" mt={8}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            ml={5}
            maxW="70px"
            borderRadius="6px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
      </Box>
    </Flex>
  );
}
